import { Link } from 'react-router-dom';
import { realCases } from '../data/content';
import './Casos.css';

function Casos() {
  return (
    <div className="casos-page">
      <div className="page-hero">
        <h1>Casos de Uso</h1>
        <p>Como transformamos processos em cada área da sua empresa.</p>
      </div>

      <section className="section">
        <div className="container">
          <div className="casos-list">
            {realCases.map((item) => (
              <Link key={item.slug} to={`/casos/${item.slug}`} className="caso-list-item">
                <div>
                  <h2>{item.area}</h2>
                  <p>{item.summary}</p>
                </div>
                <span className="caso-arrow">→</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Casos;
